type Props = {
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
};

export default function BinIcon({
  width = 17,
  height = 16,
  fill = 'none',
  stroke = 'white'
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Bin">
        <path
          id="Rectangle 1602"
          d="M4.25 5.00572L4.24932 13.0057C4.24927 13.558 4.69695 14.0058 5.24923 14.0058L11.2492 14.0063C11.8015 14.0064 12.2493 13.5587 12.2493 13.0064L12.25 5.0064"
          stroke={stroke}
          strokeLinecap="round"
        />
        <path
          id="Rectangle 1603"
          d="M10.25 4.00624L10.2501 3.00624C10.2501 2.45396 9.80246 2.0062 9.25017 2.00616L7.25017 2.00599C6.69789 2.00594 6.25013 2.45362 6.25008 3.0059L6.25 4.0059"
          stroke={stroke}
          strokeLinecap="round"
        />
        <line
          id="Line 67"
          x1="3.75004"
          y1="4.50569"
          x2="12.75"
          y2="4.50645"
          stroke={stroke}
          strokeLinecap="round"
        />
        <line
          id="Line 68"
          x1="2.75004"
          y1="4.5056"
          x2="13.75"
          y2="4.50653"
          stroke={stroke}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
